import type {
  ApiDataSourceRequest,
  ApiDataSourceResponse,
  DataSourceCandidatesRequest,
  DataSourceCandidatesResponse,
  WidgetDimensionsRequest,
  WidgetDimensionsResponse,
  WidgetEntitiesRequest,
  WidgetEntitiesResponse,
} from './config';

// -- response guards --

/**
 * Returns true when the payload is a legacy v1 tree response.
 */
export const isLegacyDataSourceResponse = (
  response: DataSourceCandidatesResponse
): response is ApiDataSourceResponse =>
  response.schema_version === '1.0.0' && response.response_type === 'tree';

/**
 * Returns true when the payload is a v2 flat dimensions response.
 */
export const isWidgetDimensionsResponse = (
  response: DataSourceCandidatesResponse
): response is WidgetDimensionsResponse =>
  response.schema_version === '2.0.0' &&
  response.response_type === 'dimensions';

/**
 * Returns true when the payload is a v2 entity list response.
 */
export const isWidgetEntitiesResponse = (
  response: DataSourceCandidatesResponse
): response is WidgetEntitiesResponse =>
  response.schema_version === '2.0.0' && response.response_type === 'entities';

// -- request guards --

/**
 * Returns true when the request asks for v2 dimension sources.
 */
export const isWidgetDimensionsRequest = (
  request: DataSourceCandidatesRequest
): request is WidgetDimensionsRequest =>
  'schema_version' in request &&
  request.schema_version === '2.0.0' &&
  request.request_type === 'dimensions';

/**
 * Returns true when the request asks for v2 project-site entities.
 */
export const isWidgetEntitiesRequest = (
  request: DataSourceCandidatesRequest
): request is WidgetEntitiesRequest =>
  'schema_version' in request &&
  request.schema_version === '2.0.0' &&
  request.request_type === 'entities';

/**
 * Returns true when the request uses the legacy v1 tree API (no schema_version).
 */
export const isLegacyDataSourceRequest = (
  request: DataSourceCandidatesRequest
): request is ApiDataSourceRequest => !('schema_version' in request);
